import fetchAPI from "@/api/api"

const URL = "/login/memberAuthController/logout/member"

const fetch = {
  url: URL,
  handler: async () => {
    try {
      await fetchAPI({
        url: URL,
        hasStatus: true,
        isOriginalBaseURL: true
      })
      return Promise.resolve()
    } catch (e) {
      return Promise.reject(e)
    }
  }
}

export default fetch
